const debug = false;
// const debug = 'EventsQueue';

export default class EventsQueue {

    public delay        : number = 300 // 0.3 sec

    public processEventsCallback    : callback
    public waitingQueue             : any[] = [] // queue of events that wait for processing
    public processingQueue          : any[] = [] // queue of events that are currently in processing

    public processingInProgress     : boolean   = false
    public debouncedProcessEventsInQueue     : any

    constructor(processEventsCallback:callback) {
        this.processEventsCallback          = processEventsCallback

        this.debouncedProcessEventsInQueue  = _.debounce(this._processEventsInQueue, this.delay);
    }

    destructor = () => {
        if (this.debouncedProcessEventsInQueue) this.debouncedProcessEventsInQueue.cancel();
    }

    /** ------------- ADD EVENT ------------- **/
    addEvent = (event:any) => {
        debug && console.log(debug, "addEvent", event)

        this.waitingQueue.push(event) // add event to waiting queue

        // do not trigger processing if it is already in progress
        // another wave of events processing would be run when previous is finished
        if (this.processingInProgress) return

        // if added event is not event of bulk update and there is only one event in waitingQueue then run processing without delay
        if (!event.header.isBulkUpdate && this.waitingQueue.length === 1) this._processEventsInQueue()
        else this.debouncedProcessEventsInQueue() // run delayed processing
    }

    /** ------------- PROCESSING ------------- **/
    _processEventsInQueue = async () => {
        // restrict run another processing while current is not finished
        this.processingInProgress = true

        // stop debounced to ensure new processing would not be triggered while current is not finished
        if (this.debouncedProcessEventsInQueue) this.debouncedProcessEventsInQueue.cancel()

        // copy current events from waiting queue to processing queue and flush waiting queue
        this.processingQueue = _.cloneDeep(this.waitingQueue)
        this.waitingQueue = []

        // process events if queue is not empty.
        // a handler that throws must not leave processingInProgress set - every later event would
        // then sit in waitingQueue forever and the view would silently stop updating
        try {
            if (!_.isEmpty(this.processingQueue)) {
                await this.processEventsCallback(this.processingQueue)
            }
        } catch (e) {
            console.error("EventsQueue: events processing failed", e, this.processingQueue)
        }

        // current processing is finished restriction to run another one is removed
        this.processingInProgress = false

        // if waiting queue is not empty then another processing should be run
        if (!_.isEmpty(this.waitingQueue)) this.debouncedProcessEventsInQueue()
    }
}